import _ from 'lodash';
import React from 'react';
import { TThemePalette } from './colors';
import defaultTheme, { TDefaultTheme } from './defaultTheme';
import { mapTypographyToCss } from './defaultTypography';
import { TTypographyTheme } from './typography.types';

export type TThemeOverride = {
  typography: TTypographyTheme;
  color: TThemePalette;
};

function useCustomTheme(theme: TThemeOverride): TDefaultTheme {
  return React.useMemo(() => {
    const newTheme = _.merge(defaultTheme, {
      color: theme.color,
      typography: theme.typography,
      mappedTypography: mapTypographyToCss(theme.typography),
    });

    return newTheme;
  }, [theme]);
}

export default useCustomTheme;
